import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

@Component({
  templateUrl: './esqueleto-interior.component.html',
  styleUrls: ['./esqueleto-interior.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EsqueletoInteriorComponent {
  constructor(private readonly cdr: ChangeDetectorRef) {}

  /**
   * Alterna el estado del sidenav (abre/cierra)
   * @param {any} sidenav - La referencia del sidenav
   * @author Juan Corral
   */
  protected alternarSideNav(sidenav: any): void {
    sidenav.toggle();
    this.cdr.markForCheck();
  }
}
